import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import PricesCH from './PricesCH.json'
import Swal from "sweetalert2";
import { updateJsonData } from "../../redux/actions/updateJsonData";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class SwissPriceTable extends Component {
  state = {
    words: {},
    lang: "En", 
    swissTableCH: [], 
    data: [], 
    fullData:[],
    preparation:'',
    dismantling:'',
    PricePerHour:'',
    SpareParts:0,
    SparePartDetails:"",
    loadedFirstTime: true,
    ALUPercentage:'',
    LAKPercentage:'',
    partsFromAE:'',
    UserEnteredSparePartsDetails:''
  };
  count = [];
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };

  componentDidMount() {
    this.getLang();
    this.getData();
    this.getJsonApi();
    // this.getFallbackDetails();
  }

  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        let newStr = [];
        const arrDataAE = [
          //1
          {
            Part : "Hood",
            dataAE : [
              "Dämmung",
              "Gitter",
            ],
            shortname : "Hood"
          },
          //2
          {
            Part : "Left Front Fender",
            dataAE : [
              "Scheinwerfer",
            ],
          },
          //3
          {
            Part : "Left Front Door",
            dataAE : [
              "Schachtleiste", 
              "Spiegel",
            ],
            shortname : "LFD"
          },
          //4
          {
            Part : "Left Back Door",
            dataAE : [
              "Schachtleiste",
            ],
            shortname : "LBD"
          },
          //5
          {
            Part : "Left Back Fender",
            dataAE : [
              "Rücklicht", 
            ],
            shortname : "LBF"
          },
          //6
          {
            Part : "Trunk",
            dataAE : [
              "Bremsleucht",
            ],
            shortname : "TR"
          },
          //7
          {
            Part : "Trunk Cover",
            dataAE : [
              "Bremsleucht",
            ],
            shortname : "TC"
          },
          //8
          {
            Part : "Right Back Fender",
            dataAE : [
              "Rücklicht",
            ],
            shortname : "RBF"
          },
          //9
          {
            Part : "Right Back Door",
            dataAE : [
              "Schachtleiste",
            ],
            shortname : "RBD"
          },
          //10
          {
            Part : "Right Front Door",
            dataAE : [
              "Schachtleiste",
              "Spiegel",
            ],
            shortname : "RFD"
          },
          //11
          {
            Part : "Right Front Fender",
            dataAE : [
              "Schachtleiste",
            ],
            shortname : "RFF"
          },
          //12
          {
            Part : "Roof",
            dataAE : [
              "Dämmung",
              "Himmel", 
            ],
            shortname : "Roof"
          },
          //13
          {
            Part : "Left Roof Frame",
            dataAE : [
              "Dachreling",
              "Dachleiste"
            ],
            shortname : "LRF"
          },
          //14
          {
            Part : "Right Roof Frame",
            dataAE :[
              "Dachreling",
              "Dachleiste"
            ],
            shortname : "RRF"
          },
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Frontscheibe", "Rahmen", "StoBstange"],
          
        ];
        if (r.data.Dents) {
          
          r.data.Dents.map((dent, index) => {
            dent.arrAE = arrDataAE[index];
            if (dent.AE) {
              dent.AE.forEach((value)=>{
                newStr.push(`${value}[${dent.arrAE.shortname}]`);
              })
            }
          });
        }
        
        this.setState({ fullData: r.data , dismantling :(r.data.Dismantling !== undefined && r.data.Dismantling >=0)  ? r.data.Dismantling : 25 , preparation:  (r.data.Preparation !== undefined || r.data.Preparation >= 0) ? r.data.Preparation : 10, PricePerHour: r.data.PricePerHour || "", SpareParts:r.data.SpareParts || 0, SparePartDetails:r.data.SparePartDetails || "", partsFromAE : newStr.toString(), UserEnteredSparePartsDetails: r.data.UserEnteredSparePartsDetails || ""}, () => {
          this.getFallbackDetails();
        })
        this.setState({ data: r.data.Dents },()=>{
          this.updateReduxJson();
          if(this.state.data) {
            this.state.data.map((dent,index) => this.getAWaAWbFirstTime(dent,index))
          }
        });
        
      }
    });
  };
  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const res = await Axios.get(
      configuration.getResultCH + "?vin=" + vin + "&partnerId=" + partnerId
    );
    if (res.data && res.data.json) {
      let { json } = res.data;
      //debugger;
      const data = json.split("\n").splice(3);
      data.pop();
      // conver data into following format
      // 1. part lt25 gt25 aw<25 aw>25

      const ltgtdataCH =
        data &&
        data.map((row) => {
          const val = row.split(/\s+/);
          let ltcount = val[2];
          let gtcount = val[3];
          return {
            part: val[1],
            count: parseInt(val[2]) + parseInt(val[3]),
            lt25: val[2],
            gt25: val[3],
            ltunit: calculatePrice(24, ltcount | 0),
            gtunit: calculatePrice(26, gtcount | 0),
            total: parseInt(val[2]) + parseInt(val[3]),
          };
        });
      this.setState({ swissTableCH: ltgtdataCH });
    }
    // debugger;
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  getTotalDents = (Dents) => {
    let totalDents =
      Dents &&
      Dents.reduce(
        (acc, num) =>
            parseInt(acc) + num.TotalDents,
        0
      );
    return totalDents;
  } 
  saveChanges = async () => {
    const{fullData}=this.state;
    this.props.getUpdatedStateFromPriceTable(false);
    this.props.updateJsonData(this.state.fullData);
    this.state.fullData['TotalDentCount'] = await this.getTotalDents(this.state.fullData.Dents)
    this.setState({
      fullData: {...this.state.fullData, IsPriceTableUpdated : true, PartnerID: localStorage.getItem(
        "partnerId"
      )},
    })
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!fullData.TabViewUpdated}`;

    Axios.post(url, this.state.fullData).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
      this.props.getUpdatedStateFromPriceTable(true);
    });
  }
  change = (part, e, index) => {
    const { name } = e.target;
    const { data, fullData } = this.state;
    if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199 ) {
      return;
    } else {
      if (e.target.checked) {
        if (name === 'check_E') {
          //uncheck Check_I_LI
          data[index]["Replace"] = "check_E";
        } else {
          //uncheck Check_E
          data[index]["Replace"] = "Check_I_LI";
        }
      } else {
        data[index]["Replace"] = "";
      }
      this.setState({ fullData }, ()=>{
        // this.props.getUpdatedStateFromPriceTable(this.state.fullData)
        this.saveChanges();
      });
    }
  };
  getTotalAw = () =>{
    const { data } = this.state;
    const total = data && data.reduce(
      (acc, num,) =>{
        if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
          return parseFloat(acc) + parseFloat(this.getAluLakAddedAW(num));
        } else { 
          return parseFloat(acc);
        }
      }
      ,
      0
    )
    return total.toFixed(2);
  }
  getAddedTotalAW = () =>{
    const {preparation, dismantling} = this.state;
    const total = parseInt(preparation) + parseInt(dismantling) + parseFloat(this.getTotalAw());
    return total;
  }
  getRepairCost = () => {
    var repairCost = (this.getAddedTotalAW() / 10 ) * parseFloat(this.state.PricePerHour) + parseFloat(this.state.SpareParts)+ parseFloat(this.getKleinMaterial()) ;
    repairCost = Intl.NumberFormat('it-CH', { currency: 'CHF',minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Math.round(repairCost*2)/2).toFixed(2));
    // repairCost = repairCost.replace(".", ",");
    return repairCost;
  }

  handleChange = (e) =>{
    const {name, value} = e.target;
    if (!value && name !== "UserEnteredSparePartsDetails") {
      this.setState({
        [ name ]: 0
      }, () =>{
        this.updateReduxJson();
      })
    } else {
      this.setState({
        [ name ]: value
      },() =>{
        this.updateReduxJson();
      })
    }
  }

  updateReduxJson = () =>{
    const { fullData, data } = this.state;

    var repairCost = (this.getAddedTotalAW() / 10 ) * parseFloat(this.state.PricePerHour) + parseFloat(this.state.SpareParts) + this.getKleinMaterial();
    fullData.Dismantling = parseFloat(parseFloat(this.state.dismantling).toFixed(2));
    fullData.Preparation = parseFloat(parseFloat(this.state.preparation).toFixed(2));
    fullData.PricePerHour = parseFloat(parseFloat(this.state.PricePerHour).toFixed(2));
    fullData.SpareParts = parseFloat(parseFloat(this.state.SpareParts).toFixed(2));
    
    if ( this.state.partsFromAE.length > 0) {
      if (this.state.UserEnteredSparePartsDetails.length > 0) {
        fullData.SparePartDetails =  this.state.UserEnteredSparePartsDetails + "," + " " + this.state.partsFromAE;
      } else {
        fullData.SparePartDetails =  this.state.partsFromAE;
      }
    } else {
      fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails ;
    }
    fullData.UserEnteredSparePartsDetails = this.state.UserEnteredSparePartsDetails;
    fullData.TotalPrice = parseFloat(parseFloat(repairCost).toFixed(2));

    //for updating the AW in json
    if (data) {
      data.forEach(row=>{
        row.AW = this.getAluLakAddedAW(row);
      })
    }
    this.setState({ data, fullData });
    this.props.updateJsonData(this.state.fullData);
  }
  handleSave = () =>{
    // const changes = this.state.changedB || this.state.changedA;
    const { fullData, data } = this.state;
    if (!!fullData) {
      var repairCost = (this.getAddedTotalAW() / 10 ) * parseFloat(this.state.PricePerHour) + parseFloat(this.state.SpareParts);
      fullData.Dismantling = parseFloat(parseFloat(this.state.dismantling).toFixed(2));
      fullData.Preparation = parseFloat(parseFloat(this.state.preparation).toFixed(2));
      fullData.PricePerHour = parseFloat(parseFloat(this.state.PricePerHour).toFixed(2));
      fullData.SpareParts = parseFloat(parseFloat(this.state.SpareParts).toFixed(2));

      if ( this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =  this.state.UserEnteredSparePartsDetails + "," + " " + this.state.partsFromAE;
        } else {
          fullData.SparePartDetails =  this.state.partsFromAE;
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails ;
      }

      fullData.UserEnteredSparePartsDetails = this.state.UserEnteredSparePartsDetails;
      fullData.TotalPrice = parseFloat(parseFloat(repairCost).toFixed(2));

      //for updating the AW in json
      data.forEach(row=>{
        row.AW = this.getAluLakAddedAW(row);
      })
      this.setState({ data, fullData },()=>{
        this.saveChanges();
      });
    }
  }

  getAWaAWb = (AWa,AWb) =>{
    if(AWa === undefined){
     AWa = 0;
    }

    if(AWb === undefined){
     AWb = 0;
    }
    let final = {
      AWa,
      AWb
    }

    if(AWa < AWb && AWa > 0){
      final.AWa = (Math.round(AWa * 0.7));
    } else if(AWa > AWb && AWb > 0){
      final.AWb = (Math.round(AWb * 0.7));
    } else if (AWa === AWb && AWa > 0 && AWb > 0) {
      final.AWa = (Math.round(AWa * 0.7));
    }
    return(final)
  }

  hadnleDentsChanges = (part, e, index) =>{
    const { data } = this.state; 
    const { name, value } = e.target;
    if(name === 'B') {
      let Val = value - (parseInt(data[index]['C']) ? data[index]['C'] : 0)
      data[index][name] = Math.abs( Val ? parseInt(Val) : 0 );
    }else {
      data[index][name] = Math.abs( value ? parseInt(value) : 0 );
    }
    data[index]["TotalDents"] = data[index]["A"] + data[index]["B"];

    const deviation = data[index]["TotalDents"] - data[index]['OriginalDents'];

    if ( deviation > 0 ) {
      data[index]['AddedCount'] = deviation;
      data[index]['RemovedCount'] = 0;
    } else {
      data[index]['RemovedCount'] = Math.abs(deviation);
      data[index]['AddedCount'] = 0;
    }

    
    if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199) {
      data[index]["Replace"] = "Check_I_LI"
    } else {
      data[index]["Replace"] = ""
    }

    /* let UpdatedAwa = [];
    
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(value)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - value)) < (Math.abs(prev.val - value)) ? curr : prev
      })
    }

    if (name === 'A') {
      data[index]["AWa"] = UpdatedAwa[0].AWa
    } else if (name === 'B'){
      data[index]["AWb"] = UpdatedAwa[0].AWb
    } */
    
    //getting AWa
    let sizeA = data[index]["A"];
    let sizeB = data[index]["B"] + data[index]["C"];
    let UpdatedAwa = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
    data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
    
    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState({
      data
    }, ()=>{
    })
  }

  handleAWchanges = (index, e) =>{
    this.setState({
      loadedFirstTime: false
    })
    const { data } = this.state; 
    const { name, value } = e.target;
    data[index][name] = ( value ? parseInt(value) : 0 );
    this.setState({
      data
    })
  }

  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);
      if (res.data) {
        this.setState({
          ALUPercentage: res.data.alu,
          LAKPercentage: res.data.lak,
        });
        if (!this.state.PricePerHour) {
          this.setState({
            PricePerHour:res.data.PricePerHour || 145,
          })
      }
      this.updateReduxJson()
      }
    } catch (error) {
      this.setState({
        ALUPercentage: "",
        LAKPercentage: "",
      });
    }
  };

  handleAluLakChanges = (e, index, key) => {
    const { data } = this.state;
    data[index][key] = e.target.checked;

    // for updating AW in json
    data[index]["AW"] = this.getAluLakAddedAW(data[index]);
    this.setState({ data }, ()=>{
      // this.props.getUpdatedStateFromPriceTable(this.state.fullData);
      this.saveChanges();
    });
  };

  // main function recalculate the AW after evey change
  updateFinalAW = (row, index) =>{

    //first apply the 70% formula and get total AW (updated values based on priceCH)
    let aw70 = this.getAWaAWb(row.AWa,row.AWb).AWa + this.getAWaAWb(row.AWa,row.AWb).AWb;

    //check if alu/lak is enabled or not
    const {ALUPercentage,LAKPercentage} = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);

    let incPR = 0;
    if (row.Alu && row.Push2paint) {
      //if Alu and lak both are enabled
      incPR = aluPr + lakPr;
    } else if (row.Alu) {
      //if only Alu is enabled
      incPR = aluPr;
    } else if (row.Push2paint) {
      //if only Push2paint is enabled
      incPR = lakPr;
    } else {
      //if only Push2paint is enabled
      incPR = 0;
    }
    if (incPR !== 0) {
      aw70 = 0 || Math.ceil(
        parseFloat(aw70) +
        (parseFloat(aw70) * incPR) /
        100.0
        );
    }
    // if (this.state.finalAW[index]) {
      this.state.finalAW[index].AW = aw70;
      this.setState({
        finalAW: this.state.finalAW,
      })
    // }
  }

  // function To generate originalAW (without alu/lak) runtime 

  // --------------Algo ------------------------ 
  // 1. take size A and B from json
  // 2. aquire AWa and AWb from priceCH based on size A and B
  // 3. Apply 70% formula 
  // 4. Add final AWa and AWb values to form original AW


  getOriginalAW = ( sizeA, sizeB, jsonAWa, jsonAWb) =>{
    // 1.) getting AWa and AWb values based on sizeA and sizeB from PriceCH 
    // ------------------------------------------------------------------------
    let AWa, AWb;
    /* let AWa = jsonAWa;
    let AWb = jsonAWb; */

    //getting AWa
    let UpdatedAwa = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
    AWa = UpdatedAwa[0].AWa; //AWa based on PriceCh
    
    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }
    AWb = UpdatedAwb[0].AWb; //AWb based on PriceCh

    

    // 2.) Applying 70% formula on updated AWa, AWb  
    // ------------------------------------------------------------------------
    // let AWa70 = this.getAWaAWb(AWa, AWa).AWa;
    // let AWb70 = this.getAWaAWb(AWa, AWa).AWb;

    if(AWa < AWb && AWa > 0){
      AWa = ((AWa * 0.7));
    } else if(AWa > AWb && AWb > 0){
      AWb = ((AWb * 0.7));
    } else if (AWa === AWb && AWa > 0 && AWb > 0) {
      AWa = ((AWa * 0.7));
    }


    // 3.) Add final AWa and AWb values to form original AW 
    // ------------------------------------------------------------------------
    let originalAW = AWa + AWb;

    return originalAW;
  }

  //function to get Alu and lak based AW
  getAluLakAddedAW = (row) =>{
    let originalAW = this.getOriginalAW(row.A, row.B+ (row.C ? row.C : 0) , row.AWa, row.AWb);
    let finalAW;

    //check if alu/lak is enabled or not
    const {ALUPercentage,LAKPercentage} = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);

    let incPR = 0;
    if (row.Alu && row.Push2paint) {
      //if Alu and lak both are enabled
      incPR = aluPr + lakPr;
    } else if (row.Alu) {
      //if only Alu is enabled
      incPR = aluPr;
    } else if (row.Push2paint) {
      //if only Push2paint is enabled
      incPR = lakPr;
    } else {
      //if only Push2paint is enabled
      incPR = 0;
    }
    if (incPR !== 0) {
      finalAW = 0 || (
        (originalAW) +
        ((originalAW) * incPR) /
        100.0
        );
    } else {
      finalAW = originalAW;
    }
    return finalAW.toFixed(2);
  }

  changeAE = (event, index, value, key) => {
    const { data, fullData } = this.state;
    const aeArr = Array.isArray(data[index]["AE"]) ? data[index]["AE"] : [];

    if (event.target.checked) {
      aeArr.push(`${value}`);
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }
    data[index]["AE"] = aeArr;

    let newStr = [];
    data.forEach((row)=>{
      if (row.AE) {
        // newStr.push(...row.AE)
        row.AE.forEach((value)=>{
          newStr.push(`${value}[${row.arrAE.shortname}]`);
        })
      }
    })
    this.setState({ data, partsFromAE: newStr.toString()},()=>{

      if ( this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =  this.state.UserEnteredSparePartsDetails + "," + " " + this.state.partsFromAE;
        } else {
          fullData.SparePartDetails =  this.state.partsFromAE;
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails ;
      }
      fullData.UserEnteredSparePartsDetails = this.state.UserEnteredSparePartsDetails;
      this.setState( { fullData }, () =>{
        this.saveChanges();
      });
    } );
  };
  
  getKleinMaterial = () => {
    const {data} = this.state
    let kleinmaterial = 0;
    if(data) {
      kleinmaterial =((isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) * this.state.PricePerHour * 0.10 * 5 ) /100 > 100 ?
                            100
                          :
                            (((data && isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) * this.state.PricePerHour * 0.10 * 5 ) /100)
    }
    return kleinmaterial.toFixed(2)
  }
  getAWaAWbFirstTime = (row,index) => {
    const { data } = this.state; 
    let sizeA, sizeB
    sizeA = row["A"];
    sizeB = row["B"];
    if( row['C'] !== undefined) {
      sizeB = sizeB + row['C'] 
    }
    let UpdatedAwa = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
   
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
   
    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price)=>{
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr)=>{
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState({
      data
    }, ()=>{
    })
  }
  getAmount = () => {
    var Amount = (isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW() * this.state.PricePerHour * 0.10);
    Amount = Intl.NumberFormat('it-CH', { currency: 'CHF',minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Math.round(Amount*2)/2).toFixed(2));
    // repairCost = repairCost.replace(".", ",");
    return Amount;
  }
  render() {
    const { Authorized } = this.state.fullData;
    const { data } = this.state;
    return (
      <>
        <div className="container mt-50 damage-summary-section p-0">
          <div className="row p-0">
            <div className="col-12 damage-summary-heading p-0 mb-1 d-flex justify-content-between">
              <div className='row p-0'>
                <div className='col-8 p-0'>
                <h3>{this.lang("Damage Description")} </h3>
                </div>
                <div className='col-4 text-right p-0'>
                {this.props.viewType === 'TabView' && 
              <button 
              //  className='SubmitBut'
                id='updateTable'
                style={{
                  // padding:'5px',
                  backgroundColor:'#F20000', 
                  padding: "5px 10px",
                  color : 'white',
                  border: "none",
                  borderRadius: "5px",
                  fontSize: "16px",
                  
                }}
                disabled={Authorized}
                onClick={this.handleSave}
              >
                  {this.lang("Update Table")}
              </button> }
                </div>
              </div>
              
            </div>
          </div>
          <div className="row p-0 damage-summary-table">
            <div className="col-lg-12 p-0">
              <table width="100%" className="table table-responsive  w-100">
                <tbody width="100%">
                  <tr width="100%">
                    <th className="damage-description-tr" width="20%">
                      {this.lang("DamageDescription")}
                    </th>
                    
                    
                 
                    <th className="swiss-sw-tr" width="7%">
                      {this.lang("ALU")}
                    </th>
                    <th className="swiss-sw-tr" width="7%">
                    {this.lang("KT")}
                    </th>
                    {
                      this.props.viewType !== "TabView" && 
                      <th className="swiss-sw-tr" width="7%">

                      </th>
                    }
                    <th className="swiss-size-tr" colSpan="2">
                      {this.lang("Size")}
                    </th>
                    <th className="swiss-sw-tr" colSpan="2">
                      {this.lang("AW")}
                    </th>
                    {
                      this.props.viewType === "TabView" && 
                     <>
                      <th className="swiss-sw-tr" width="20%">
                      </th>
                      <th className="swiss-sw-tr">
                      </th>
                     </>
                    }
                    {/* sd';gjnsdio */}
                    <th colSpan="2">{this.lang("Total")}</th>
                  </tr>
                  <tr width="100%">
                    <th></th>
                    {/* <th width="50%">{this.lang("Part")}</th> */}
                    <th>{this.state.ALUPercentage && `(${parseInt(this.state.ALUPercentage)}%)`}</th>
                    <th>{this.state.LAKPercentage && `(${parseInt(this.state.LAKPercentage)}%)`}</th>
                    {
                      this.props.viewType !== "TabView" && 
                      <th>{this.lang("")}</th>
                    }
                    <th width="7%">{""} {this.lang("A")}</th>
                    <th width="7%">{""} {this.lang("B")}</th>
                    <th width="7%">{""} {this.lang("A")}</th>
                    <th width="7%">{""} {this.lang("B")}</th>
                    {
                      this.props.viewType === "TabView" && 
                      <>
                      <th>{this.lang("A + E")}</th>
                      <th>{this.lang("Replace")}</th>
                      </>
                    }
                    <th width="8%">{this.lang("Dent Count")}</th>
                    <th width={this.props.viewType==='TabView'?'10%':'10%'}>{this.lang("AW")}</th>
                    {/* <th width="10%">{this.lang("Price")}</th> */}
                  </tr>
                  
                  {data &&
                    data.map((row, index) => (
                      row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" && 
                      <tr key={index}>
                        {/* parts */}
                        <td>{this.lang(row.Part)}</td>
                        
                        <th>
                          {
                            this.props.viewType === 'TabView' ? 
                              <input type='checkbox'
                              checked={row.Alu}
                              disabled={Authorized}
                              onChange={(e) => {
                                this.handleAluLakChanges(e, index, "Alu");
                              }}
                            /> :
                            row.Alu ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                          }
                        </th>
                        
                        <th>
                        {
                          this.props.viewType === 'TabView' ? 
                            <input type='checkbox'
                              checked={row.Push2paint}
                              onChange={(e) => {
                                this.handleAluLakChanges(e, index, "Push2paint");
                              }}
                              disabled={Authorized}
                            />
                          :
                          row.Push2paint ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                        }
                        </th>
                       
                        {
                          this.props.viewType !== "TabView" && 
                            <td className="" style={{
                              textAlign: "center",
                              }}
                            >
                              {row.Replace ? row.Replace ==='check_E'? 'E':'I/LI' : '' }
                            </td>
                        }
                        <td className="" style={{ textAlign: "center" }}>
                          {
                            this.props.viewType === "TabView" ? 

                              <input
                                name="A"
                                type='number'
                                min='0'
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                value={data[index]['A']}
                                onChange={(e) => {
                                  this.hadnleDentsChanges(row.part, e ,index);
                                }}
                                disabled={Authorized}
                              />
                              : data[index]['A']
                          }
                          {/* {row.A} */}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                        {
                            this.props.viewType === "TabView" ? 
                              <input
                                name="B"
                                type='number'
                                min='0'
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                value={data[index]['B'] + (data[index]['C'] ? data[index]['C'] : 0)}
                                onChange={(e)=>{
                                  this.hadnleDentsChanges(row.part, e ,index);
                                }}
                                disabled={Authorized}
                              />
                              : data[index]['B'] + (data[index]['C'] ? data[index]['C'] : 0)
                          }
                          {/* {row.B} */}
                        </td>

                        <td className="" style={{ textAlign: "center" }}>
                          {/* {this.props.viewType === 'TabView' ? 
                            this.state.loadedFirstTime ? 
                              <input 
                                type='number'
                                name = 'AWa'
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                min='0'
                                disabled
                                value = {this.getAWaAWb(row.AWa, row.AWb).AWa} 
                                onChange = {(e)=>{
                                  this.handleAWchanges(index, e);
                                }}
                              /> :  
                              <input 
                                type='number'
                                name = 'AWa'
                                disabled
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                min='0'
                                value = {row.AWa} 
                                onChange = {(e)=>{
                                  this.handleAWchanges(index, e);
                                }}
                              />
                            :
                            this.getAWaAWb(row.AWa, row.AWb).AWa
                          } */}
                          {row.AWa}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                        {/* {this.props.viewType === 'TabView' ? 
                            this.state.loadedFirstTime ? 
                              <input 
                                type='number'
                                name = 'AWb'
                                value = {this.getAWaAWb(row.AWa, row.AWb).AWb} 
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                min='0'
                                disabled
                                onChange = {(e)=>{
                                  this.handleAWchanges(index, e);
                                }}
                              /> :  
                              <input 
                                type='number'
                                name = 'AWb'
                                style={{width : '100%', border:'none', outline: 'none', textAlign:'center'}}
                                min='0'
                                disabled
                                value = {row.AWb} 
                                onChange = {(e)=>{
                                  this.handleAWchanges(index, e);
                                }}
                              />
                            :
                            this.getAWaAWb(row.AWa, row.AWb).AWb
                          } */}
                          {row.AWb}
                          {/* {this.getAWaAWb(row.AWa, row.AWb).AWb} */}
                        </td>

                        {
                          this.props.viewType === "TabView" && 
                          <>
                            <td>
                              <div className="ae-content p-0">
                                <div className="row p-0">
                                  {Array.isArray(row.arrAE.dataAE) &&
                                    row.arrAE.dataAE.map((checkbox_val) => {
                                      return (
                                        <>
                                          <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                            <div className="row p-0">
                                              <div className="col-2 p-0">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    Array.isArray(
                                                      data[index]["AE"]
                                                    ) &&
                                                    data[index]["AE"].includes(
                                                      checkbox_val
                                                    )
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={(event) =>
                                                    this.changeAE(
                                                      event,
                                                      index,
                                                      checkbox_val
                                                    )
                                                  }
                                                  disabled={Authorized}
                                                />
                                              </div>
                                              <div className="col-10 p-0">
                                                <p>{checkbox_val}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                </div>
                              </div>
                            </td>
                            <td className="" style={{ textAlign: "center" }}>
                            {/* <input
                              className="custom-control-input"
                              type="checkbox"
                              checked={row.Replace}
                              onChange={(e) => {
                                this.change(row.part, e, index);
                              }}
                              id={index + "Replace1"}
                            /> */}
                             <div className="row p-0">
                              <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                  <div className="row p-0">
                                    <div className="col-6 p-0">
                                      <input
                                        type="checkbox"
                                        checked={row.Replace==='check_E'}   
                                        name='check_E'
                                        onChange={(e) => {
                                          this.change(row.part, e, index);
                                        }}  
                                        disabled={Authorized}  
                                      />
                                      </div>
                                        <div className="col-6 p-0">
                                          <p>E</p>
                                        </div>
                                      </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                  <div className="row p-0">
                                    <div className="col-6 p-0">
                                      <input
                                        type="checkbox"
                                        checked={row.Replace==='Check_I_LI'}    
                                        name="check_I_LI"
                                        onChange={(e) => {
                                          this.change(row.part, e, index);
                                        }}   
                                        disabled={Authorized} 
                                      />
                                    </div>
                                    <div className="col-6 p-0">
                                      <p>I/LI</p>
                                    </div>
                                  </div>
                                </div>                                          
                              </div>
                          </td>
                          </>
                        }

                        <td className="" style={{ textAlign: "center", color:`${ (row.TotalDents > 607 || row.B > 199 ) ? 'red' : ''}` }}>
                          {row.TotalDents}
                          {/* {data[index]['A'] + data[index]['B']} */}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                          {/* { this.state.finalAW[index] && this.state.finalAW[index].AW}  */}
                          {/* { row.AW} */}
                          { this.getAluLakAddedAW(row) }
                          {/* ldsndg */}
                        </td>
                        {/* <td className="" style={{ textAlign: "center" }}>
                          -
                        </td> */}
                      </tr>
                    ))}

                  <tr>
                    <td style={{ fontWeight: "bold" }}>{this.lang("Total")}</td>
                    {
                      this.props.viewType !== 'TabView' && 
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>-</td>
                    }
                    <th>-</th>
                    <th>-</th>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {" "}
                      {data &&
                        data.reduce(
                          (acc, num) => {
                            if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                              return parseInt(acc) + parseInt(num.A) 
                            } else { 
                              return parseInt(acc)
                            }
                            
                          },
                          0
                        )}
                    </td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {" "}
                      {data &&
                        data.reduce(
                          (acc, num) =>{
                            if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                              return parseInt(acc) + parseInt(num.B) + (parseInt(num.C) ? parseInt(num.C) : 0);
                            } else { 
                              return parseInt(acc);
                            }
                          },
                          0
                        )}{" "}
                    </td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {" "}
                      {data && 
                        data.reduce(
                          (acc, num) =>{
                            if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                              return (parseInt(acc) + num.AWa);
                            } else { 
                              return parseInt(acc);
                            }
                          },
                          0
                        )
                      }
                    </td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>

                      {" "}
                      {data && 
                        data.reduce(
                          (acc, num) =>{
                            if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                              return (parseInt(acc) + num.AWb);
                            } else { 
                              return parseInt(acc);
                            }
                          },
                          0
                          )
                      }
                    </td>
                    {
                      this.props.viewType === 'TabView' && 
                      <>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>-</td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>-</td>
                      </>
                    }
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {" "}
                      {data &&
                        data.reduce(
                          (acc, num) =>{
                            if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                              return parseInt(acc) + parseInt(num.TotalDents);
                            } else { 
                              return parseInt(acc);
                            }
                          },
                          0
                        )}
                    </td>
                    

                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {data && isNaN(this.getTotalAw()) ? 0 : this.getTotalAw()} 
                    </td>
                    {/* <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      -
                    </td> */}
                  </tr>


                  <tr>
                    <td style={{ fontWeight: "bold",border:'none' }}></td>
                    {/* { this.props.viewType === 'TabView' && <td style={{ fontWeight: "bold",border:'none' }}></td>} */}
                    {/* {
                      this.props.viewType === 'TabView' ? 
                      <>
                        <td style={{ fontWeight: "bold",textAlign:'center' }}>
                          <button
                            style={{
                              // padding:'5px',
                              backgroundColor:'#F20000', 
                              padding: "5px 10px",
                              color : 'white',
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "16px",
                            }}
                            onClick = {this.handleDentsSaveA}
                          >
                            Save
                          </button>
                        </td>

                        <td style={{ fontWeight: "bold", textAlign:'center'}}>
                          <button
                            style={{
                              // padding:'5px',
                              backgroundColor:'#F20000', 
                              padding: "5px 10px",
                              color : 'white',
                              border: "none",
                              borderRadius: "5px",
                              fontSize: "16px",
                            }}
                            onClick = {this.handleDentsSaveB}
                          >
                              Save
                          </button>
                        </td>
                      </> 
                      : 
                      <>
                        <td style={{ fontWeight: "bold",border:'none' }}></td>
                      </>
                        
                    } */}
                    
                    <td colSpan={  this.props.viewType === "TabView" ? "9" : "8"} className="" 
                      style={{ textAlign: "right", fontWeight:"normal" }}
                    >
                        {this.lang('Preparation AW')}
                    </td>
                    <td
                      colSpan='1'
                      style={{textAlign:"center", fontWeight:"normal" }}
                    >
                      {
                        this.props.viewType === "TabView" ? 
                          <input 
                            type="number"
                            style={{width : '100%', border:'none', outline: 'none',  textAlign:"center"}}
                            value={this.state.preparation}
                            name="preparation"
                            onChange={this.handleChange}
                            disabled={Authorized}
                            // width='100%'
                          /> : 
                          this.state.preparation
                      }
                    
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold",border:'none' }}></td>
                    {/* { this.props.viewType === 'TabView' && <td style={{ fontWeight: "bold",border:'none' }}></td>} */}
                    <td colSpan={  this.props.viewType === "TabView" ? "9" : "8"} className="" 
                      style={{ textAlign: "right", fontWeight:"normal"}}
                    >
                        {this.lang('Dismantling- and Assembly fee AW')}
                    </td>
                    <td
                    colSpan='1'
                      style={{  textAlign:"center", fontWeight:"normal"}}
                    >
                      {
                        this.props.viewType === "TabView" ? 
                          <input 
                            type="number"
                            style={{width :'100%', border:'none', outline: 'none',  textAlign:"center" }}
                            onChange={this.handleChange}
                            name="dismantling"
                            value={this.state.dismantling}
                            disabled={Authorized}
                              // width='100%'
                          /> : 
                          this.state.dismantling
                      }
                    </td>
                    {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                  </tr>
                  
                        {
                           this.props.viewType === "TabView" && 
                            <>
                              <tr>
                                <td style={{ fontWeight: "bold",border:'none' }}></td>
                                <td 
                                  colSpan={  this.props.viewType === "TabView" ? "9" : "8"}
                                  style={{ textAlign: "right", fontWeight:"normal"}}
                                >
                                    {this.lang('Price/hr')}
                                </td>
                                <td colSpan='2' style={{textAlign: "center", fontWeight:"normal"}}>
                                  { this.props.viewType === "TabView" ? 
                                    <input 
                                    type="number"
                                    style={{width :'100%', border:'none', outline: 'none',  textAlign:"center"}}
                                    onChange={this.handleChange}
                                    name="PricePerHour"
                                    value={this.state.PricePerHour}
                                    disabled={Authorized}
                                    // width='100%'
                                    /> :
                                    this.state.PricePerHour
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold",border:'none' }}></td>
                                <td colSpan={this.props.viewType === 'TabView' ?  "9" : "8"} className="text-right m-0"><p>{this.lang("Amount")} </p> </td>                      
                                <td className={"text-right"}>
                                  <table className="w-100 p-0">
                                    <tr>
                                      <td className="p-0 text-center" style={{ fontWeight: "normal",border:'none', fontSize:"14px" }}><b>Fr.</b></td>
                                      <td style={{border:'none', padding : 0}} className={"text-right"}>
                                        <p className="p-0 m-0"><b>{this.getAmount()}</b></p>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold",border:'none' }}></td>
                                <td  colSpan={  this.props.viewType === "TabView" ? "9" : "8"} style={{ textAlign: "right", fontWeight:"normal"}}>
                                  <p>{this.lang("Small materials 5% max.Fr 100")}</p>
                                </td>
                                {/* <td className="blank_row"></td> */}
                                <td className={"text-center"}>
                                <table className="w-100">
                                      <tr>
                                        <td className="p-0 text-center" style={{fontWeight: "normal",border:'none', fontSize:"14px" }}>
                                          Fr.
                                        </td>
                                        <td style={{border : "none", padding: 0}} className="text-center">
                                        <p className="p-0 m-0">{this.getKleinMaterial()}</p>
                                        </td>
                                      </tr>
                                </table>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold",border:'none' }}></td>
                                 {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                                <td colSpan={"9"} className="" 
                                  style={{ textAlign: "right", fontWeight:"normal", borderBottom : 'none' }}
                                >
                                  <table className="w-100">
                                    <tr className="w-100">
                                      <td width="30%" style={{border:"none", textAlign:"left", fontWeight:"normal"}}>{this.lang('Spare Parts cost')}:</td>
                                      <td width="70%" style={{border:"none", textAlign:"right"}}>      
                                          <input 
                                            type="text" 
                                            className="form-control" 
                                            name="UserEnteredSparePartsDetails"
                                            value={this.state.UserEnteredSparePartsDetails}
                                            onChange={this.handleChange}
                                            disabled={Authorized}
                                            style={{width :'100%', border:'none', outline: 'none',  textAlign:"right" , boxShadow:"none"}}
                                          />
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td
                                colSpan='2'
                                  style={{  textAlign:"center", fontWeight:"normal", borderBottom : 'none'}}
                                >
                                  <table>
                                    <tr>
                                      <td style={{ fontWeight: "normal",border:'none', fontSize:"14px" }}>Fr.</td>
                                      <td style={{ fontWeight: "bold",border:'none' }}>
                                        {
                                        this.props.viewType === "TabView" ? 
                                        <input 
                                          type="number"
                                          min='0'
                                          style={{width :'100%', border:'none', outline: 'none',  textAlign:"center" }}
                                          onChange={this.handleChange}
                                          name="SpareParts"
                                          value={this.state.SpareParts}
                                          disabled={Authorized}
                                            // width='100%'
                                        /> : 
                                        this.state.SpareParts
                                        }
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                              </tr>
                              {this.state.partsFromAE.length > 0 && 
                                <tr>
                                  <td style={{ fontWeight: "bold",border:'none' }}></td>
                                  <td colSpan={"9"} className="" 
                                    style={{ textAlign: "right", fontWeight:"normal", borderTop : 'none'}}
                                  >
                                      {this.state.partsFromAE}
                                  </td>
                                  <td
                                  colSpan='2'
                                    style={{  textAlign:"center", fontWeight:"normal", borderTop : 'none'}}
                                  >
                                  </td>
                                </tr>
                              }
                              <tr>
                                <td style={{ fontWeight: "bold",border:'none' }}></td>
                                <td 
                                  colSpan='9' 
                                  id="print_table_bg_replace" 
                                  style={{ textAlign: "right",color:'white', backgroundColor:'#0384C8' }}
                                >
                                    {this.lang('Repair costs')}
                                </td>
                                <td
                                  id="print_table_bg_value"
                                  colSpan='1'
                                  style={{ fontWeight: "bold",color:'white', backgroundColor:'#0384C8',textAlign:'right' }}
                                >
                                  Fr. { data && this.getRepairCost( data,this.state.preparation, this.state.dismantling) }
                                </td>
                                {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                              </tr>
                            </>
                        }

                  {
                    this.props.viewType !== "TabView" && 
                     (
                       <>


                        <tr>
                          <td style={{ fontWeight: "bold",border:'none' }}></td>
                          <td colSpan='8' className="" 
                            style={{ textAlign: "right",fontWeight:"normal"  }}
                          >
                              {this.lang('Total AW')}
                          </td>
                          <td
                          colSpan='1'
                            style={{ textAlign:"center", fontWeight:"normal" }}
                          >
                            { data && isNaN(this.getAddedTotalAW(data, this.state.preparation, this.state.dismantling)) ? 0
                             : this.getAddedTotalAW(data, this.state.preparation, this.state.dismantling)
                            }
                          </td>
                          {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold",border:'none' }}></td>
                          <td colSpan={this.props.viewType === 'TabView' ?  "9" : "8"} className="text-right m-0"><p>{this.lang("Amount")} </p> </td>                      
                          <td className={"text-right"}>
                            <table className="w-100 p-0">
                              <tr>
                                <td className="p-0 text-center" style={{ fontWeight: "normal",border:'none', fontSize:"14px" }}><b>Fr.</b></td>
                                <td style={{border:'none', padding : 0}} className={"text-right"}>
                                  <p className="p-0 m-0"><b>{this.getAmount()}</b></p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold",border:'none' }}></td>
                          <td  colSpan={  this.props.viewType === "TabView" ? "9" : "8"} style={{ textAlign: "right", fontWeight:"normal"}}>
                            <p>{this.lang("Small materials 5% max.Fr 100")}</p>
                          </td>
                          {/* <td className="blank_row"></td> */}
                          <td className={"text-center"}>
                          <table className="w-100">
                                <tr>
                                  <td className="p-0 text-center" style={{fontWeight: "normal",border:'none', fontSize:"14px" }}>
                                    Fr.
                                  </td>
                                  <td style={{border : "none", padding: 0}} className="text-center">
                                  <p className="p-0 m-0">{this.getKleinMaterial()}</p>
                                  </td>
                                </tr>
                          </table>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold",border:'none' }}></td>
                          <td colSpan={'8'} className="" 
                            style={{ textAlign: "right", fontWeight:"normal"}}
                          >
                            <table className="w-100">
                              <tr className="w-100">
                                <td width="30%" style={{border:"none", textAlign:"left", fontWeight:"normal"}}><span style={{fontSize:"15px", whiteSpace:"nowrap"}}>{this.lang('Spare Parts cost')}:</span></td>
                                <td width="70%" style={{border:"none", textAlign:"right", fontWeight:"normal"}}>      
                                  {this.state.SparePartDetails}
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td
                          colSpan='1'
                            style={{  textAlign:"center", fontWeight:"normal"}}
                          >
                            Fr. {Intl.NumberFormat('it-CH', { currency: 'CHF',minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Math.round(this.state.SpareParts * 2) / 2).toFixed(2))}
                          </td>
                          {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold",border:'none' }}></td>
                          <td 
                            colSpan='8' 
                            id="print_table_bg_replace" 
                            style={{ textAlign: "right",color:'white', backgroundColor:'#0384C8' }}
                          >
                              {this.lang('Repair costs')}
                          </td>
                          <td
                            id="print_table_bg_value"
                            colSpan='1'
                            style={{ fontWeight: "bold",color:'white', backgroundColor:'#0384C8',textAlign:'right' }}
                          >
                            Fr. { data && this.getRepairCost( data,this.state.preparation, this.state.dismantling) }
                          </td>
                          {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                        </tr>
                       </>
                     )
                  }
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    jsonData : props.jsonData
  };
};

export default connect(mapStateToProps,{
  updateJsonData
})(SwissPriceTable);
